import React from 'react';
import './custom-dropdown.css';
import { ReactComponent as ArrowDownIcon } from '../../assets/icons/down-arrow.svg';
function CustomDummyDropdown({ label }) {
  return (
    <div className="custom-dropdown">
      {label}
      <ArrowDownIcon
        color="rgb(89, 89, 89)"
        style={{ width: 24, height: 24 }}
      />
    </div>
  );
}

export default CustomDummyDropdown;
